<template>
	<div data-tour-scope="whatsapp">
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center>
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title> Whatsapp</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>
							<v-spacer></v-spacer>
						</v-toolbar>


						<!-- ricerca in pagina: finisce nell'URL con pagina, righe e ordinamento -->
						<v-col cols="12">
							<v-row>
								<v-col cols="12" md="4" data-tour="search">
									<v-text-field
										v-model="searchfield"
										label="Cerca numero o nome"
										outlined
										dense
										append-icon="mdi-magnify"
										hide-details
										@click:append="getSearch()"
										@keyup.enter="getSearch()"
									></v-text-field>
								</v-col>
							</v-row>
						</v-col>

						<v-data-table
							:headers="headers"
							:items="getChats"
							:options.sync="settings.options"
							:server-items-length="total"
							must-sort
							class="elevation-0"
							:footer-props="{ 'items-per-page-options': listSize }"
							item-key="_id"
							:mobile-breakpoint="0"
							data-tour="table"
							:hide-default-header="mobileCards"
							:class="{ 'table-cards': mobileCards }"
						>
							<template v-slot:body="{ items }">
								<!-- telefono: ogni chat e' una card; la conversazione si apre DENTRO la card -->
								<tbody v-if="mobileCards" class="whatsapp-cards">
									<tr v-for="item in items" :key="item._id">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card :title="item.name || item.contact || 'Contatto'" :fields="campiCard(item)">
												<template v-slot:actions>
													<v-menu top eager>
														<template v-slot:activator="{ on, attrs }">
															<v-btn icon small color="primary" v-bind="attrs" v-on="on" data-tour="row-menu">
																<v-icon>mdi-dots-vertical</v-icon>
															</v-btn>
														</template>
														<v-list>
															<v-list-item link @click="extension(item._id)">
																<v-list-item-title class="size9">{{ checkpresenza(item._id) ? 'Chiudi conversazione' : 'Apri conversazione' }}</v-list-item-title>
															</v-list-item>
															<v-list-item link @click="copyContact(item)">
																<v-list-item-title class="size9">Copia numero</v-list-item-title>
															</v-list-item>
														</v-list>
													</v-menu>
													<v-btn small icon color="primary" data-tour="expand" :title="checkpresenza(item._id) ? 'Chiudi conversazione' : 'Apri conversazione'" @click="extension(item._id)">
														<v-icon>{{ checkpresenza(item._id) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
													</v-btn>
												</template>
												<template v-slot:top>
													<div v-if="item.messages.length > 0 && !checkpresenza(item._id)" class="wa-last mb-2">
														<div class="card-label mb-1">Ultimo messaggio</div>
														<MessagePreview :message="item.messages[0]" :contact="item.contact" />
													</div>
												</template>
												<template v-if="checkpresenza(item._id)">
													<ChatThread
														:item="item"
														:uploading="uploading === item._id"
														@upload="file => imageBrowse(file, { objectKey: item.post, id: item._id })"
														@remove-attach="index => deleteAttach(index, item.post)"
														@send="askSend(item)"
													/>
												</template>
											</key-value-card>
										</td>
									</tr>
									<tr v-if="!items.length">
										<td :colspan="headers.length" class="text-center grey--text py-6">Nessuna chat</td>
									</tr>
								</tbody>
								<tbody v-else>
									<template v-for="item in items">
										<tr :key="item._id">
											<td class="pl-0 pr-0 ml-0 mr-0" style="width: 5px">
												<v-menu top eager>
													<template v-slot:activator="{ on, attrs }">
														<v-btn icon dark v-bind="attrs" v-on="on" color="primary" dense data-tour="row-menu">
															<v-icon dark> mdi-dots-vertical </v-icon>
														</v-btn>
													</template>
													<v-list>
														<v-list-item link @click="extension(item._id)">
															<v-list-item-title class="size9">{{ checkpresenza(item._id) ? 'Chiudi conversazione' : 'Apri conversazione' }}</v-list-item-title>
														</v-list-item>
														<v-list-item link @click="copyContact(item)">
															<v-list-item-title class="size9">Copia numero</v-list-item-title>
														</v-list-item>
													</v-list>
												</v-menu>
											</td>
											<td class="pl-0 pr-0" style="width: 5px">
												<v-btn small icon data-tour="expand" :title="checkpresenza(item._id) ? 'Chiudi conversazione' : 'Apri conversazione'" @click="extension(item._id)">
													<v-icon>{{ checkpresenza(item._id) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
												</v-btn>
											</td>
											<td class="text-left">{{ item.lastmessage | moment('DD/MM/YYYY HH:mm:ss') }}</td>
											<td class="text-left">{{ item.contact }}</td>
											<td class="text-left">{{ item.name }}</td>
											<td class="text-left">
												<MessagePreview v-if="item.messages.length > 0" :message="item.messages[0]" :contact="item.contact" />
											</td>
											<td class="text-left">{{ item.lang }}</td>
											<td class="text-left">{{ item.messages.length }}</td>
										</tr>

										<tr v-if="checkpresenza(item._id)" :key="item._id + '-chat'" class="wa-expanded">
											<td :colspan="headers.length" class="py-3">
												<ChatThread
													:item="item"
													:uploading="uploading === item._id"
													@upload="file => imageBrowse(file, { objectKey: item.post, id: item._id })"
													@remove-attach="index => deleteAttach(index, item.post)"
													@send="askSend(item)"
												/>
											</td>
										</tr>
									</template>
									<tr v-if="!items.length">
										<td :colspan="headers.length" class="text-center grey--text py-6">Nessuna chat</td>
									</tr>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar.snackbar = false"> Chiudi </v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>

		<!-- il messaggio parte davvero, verso un numero vero, e non si puo' ritirare: si chiede conferma -->
		<v-dialog v-model="dialogSend" max-width="420">
			<v-card>
				<v-card-title class="headline">Inviare il messaggio?</v-card-title>
				<v-card-text class="text-left">
					Il messaggio parte subito su WhatsApp verso
					<b>{{ pendingSend && (pendingSend.name || pendingSend.contact) }}</b
					><template v-if="pendingSend && pendingSend.name"> ({{ pendingSend.contact }})</template> e non si può ritirare.
					<template v-if="pendingSend && pendingSend.post.attachs.length"><br />Con {{ pendingSend.post.attachs.length === 1 ? 'un allegato' : pendingSend.post.attachs.length + ' allegati' }}.</template>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text color="primary" @click="cancelSend">Annulla</v-btn>
					<v-btn text color="primary" @click="confirmSend">Invia</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- Ultimo elemento: il nodo viene spostato in `[data-app]` al montaggio. -->
		<TourOverlay :tour="tour"></TourOverlay>
	</div>
</template>

<script>
import _ from 'lodash';
import axios from 'axios';
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import { useTour } from '@/components/core/tour/useTour';
import { listRouteState } from '@/components/core/list/listRouteState';
import { createWhatsappTourSteps, stopWhatsappTour } from './whatsapp-tour';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import { uuid } from 'vue-uuid';

import ChatThread from '@/components/whatsapp/ChatThread.vue';
import MessagePreview from '@/components/whatsapp/MessagePreview.vue';

// sotto i 3 caratteri la ricerca non parte (il backend la ignora)
const SEARCH_MIN = 3;
const LIST_SIZE = [15, 25, 50, 100];

export default {
	name: 'WhatsappIndex',
	// pagina, righe, ordinamento e ricerca stanno nell'URL: un refresh riparte da li'
	mixins: [listRouteState({ perPageOptions: LIST_SIZE })],
	setup() {
		return { tour: useTour(createWhatsappTourSteps(), { onStop: stopWhatsappTour }) };
	},
	data() {
		return {
			// _id della chat con un allegato in caricamento
			uploading: null,
			// _id delle conversazioni aperte sotto la loro riga
			selected: [],
			// chat in attesa della conferma d'invio
			pendingSend: null,
			dialogSend: false,

			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
			settings: this.listSettingsFromRoute({
				search: '',
				filters: {},
				options: {
					sortBy: ['lastmessage'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15,
				},
			}),
			searchfield: '',
			listSize: LIST_SIZE,
			total: 0,
			headers: [
				// menu a tre puntini e apertura della conversazione: non si ordinano
				{ text: '', value: 'menu', sortable: false },
				{ text: '', value: 'expand', sortable: false },
				{ text: 'Data', value: 'lastmessage' },
				{ text: 'Contatto', value: 'contact' },
				{ text: 'Nome', value: 'name' },
				{ text: 'Ultimo messaggio', value: 'preview', sortable: false },
				{ text: 'Lingua', value: 'lang', sortable: false },
				{ text: 'Messaggi', value: 'messages', sortable: false },
			],
		};
	},
	created() {
		this.setExistFilter(true);
		this.listLoad();
	},
	components: {
		KeyValueCard,
		TourOverlay,
		ChatThread,
		MessagePreview,
	},
	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		...mapGetters({
			getToken: 'profile/getToken',
			getUrl: 'settings/getUrl',
			getChats: 'whatsapp/getItems',
		}),
	},
	methods: {
		// stessi dati delle colonne Data/Contatto/Lingua/Messaggi della tabella desktop
		campiCard(item) {
			return [
				{ label: 'Data', value: item.lastmessage ? this.$moment(item.lastmessage).format('DD/MM/YYYY HH:mm:ss') : '' },
				{ label: 'Contatto', value: item.contact },
				{ label: 'Lingua', value: item.lang },
				{ label: 'Messaggi', value: item.messages ? item.messages.length : 0, strong: true },
			];
		},
		...mapMutations({
			setLogout: 'profile/setLogout',
			setPreload: 'settings/setPreload',
			setExistFilter: 'settings/setExistFilter',
		}),
		...mapActions({
			fetchChats: 'whatsapp/asyncFetchData',
			destroyData: 'whatsapp/destroyData',
		}),
		notify(color, text) {
			this.snackbar.color = color;
			this.snackbar.text = text;
			this.snackbar.snackbar = true;
			this.snackbar.mode = 'multi-line';
			this.snackbar.timeout = 5000;
		},
		// il mixin della lista riporta a pagina 1 e ricarica quando cambia la ricerca
		getSearch() {
			this.settings.search = _.size(this.searchfield) >= SEARCH_MIN ? this.searchfield : '';
		},
		getDataFromApi() {
			this.setPreload(true);
			return this.fetchChats(this.settings)
				.then(result => {
					this.total = (result && result.total) || 0;
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.setPreload(false);
				});
		},
		async imageBrowse(file, extraData = {}) {
			if (file && file.name) {
				const formData = new FormData();
				formData.append('file', file, file.name);
				formData.append('uuid', uuid.v4());

				this.uploading = extraData.id || null;
				try {
					const response = await axios.post(`${this.getUrl}multimedias/uploadfile`, formData, {
						headers: {
							'Content-Type': 'multipart/form-data',
							Authorization: `Bearer ${this.getToken}`,
						},
					});

					// $set: l'assegnazione per indice non e' reattiva in Vue 2 (il chip dell'allegato non comparirebbe)
					this.$set(extraData.objectKey.attachs, 0, { url: response.data.url });
				} catch (err) {
					this.notify('error', 'Caricamento del file non riuscito');
				} finally {
					this.uploading = null;
				}
			}
		},
		deleteAttach(index, post) {
			post.attachs.splice(index, 1);
		},
		// Invio dalla conversazione (pulsante o Invio): prima la conferma
		askSend(item) {
			this.pendingSend = item;
			this.dialogSend = true;
		},
		cancelSend() {
			this.dialogSend = false;
			this.pendingSend = null;
		},
		confirmSend() {
			const item = this.pendingSend;
			this.dialogSend = false;
			this.pendingSend = null;
			if (item) this.save({ ...item.post, id: item._id }, item.post);
		},
		// target: il post originale della chat, da svuotare dopo l'invio (post e' una copia)
		save(post, target = post) {
			axios
				.post(`${this.getUrl}whatsapp/send`, post, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(() => {
					this.notify('success', 'Messaggio inviato');

					target.text = '';
					target.type = '';
					target.attachs = [];
					// ricarica le chat per mostrare subito il fumetto inviato (le chat aperte restano aperte)
					this.getDataFromApi();
				})
				.catch(err => {
					if (err.response) {
						const errors = err.response.data && err.response.data.error;
						if (errors && !_.isArray(errors)) {
							err.message = errors;
						} else if (_.isArray(errors) && errors.length) {
							err.message = errors.map(e => e.msg).join(', ');
						}
						this.notify('error', err.message);
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		copyContact(item) {
			const value = String(item.contact || '');
			if (navigator.clipboard && navigator.clipboard.writeText) {
				navigator.clipboard.writeText(value).then(
					() => this.notify('success', 'Numero copiato'),
					() => this.notify('error', 'Copia non riuscita'),
				);
			} else {
				this.notify('error', 'Copia non disponibile in questo browser');
			}
		},
		extension(id) {
			const index = this.selected.indexOf(id);
			if (index === -1) {
				this.selected.push(id);
			} else {
				this.selected.splice(index, 1);
			}
		},
		checkpresenza(id) {
			return this.selected.includes(id);
		},
	},
	beforeDestroy() {
		this.tour.stop();
		this.destroyData();
	},
};
</script>

<style scoped>
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.whatsapp-cards,
.whatsapp-cards tr {
	display: block;
	width: 100%;
}
.whatsapp-cards tr,
.whatsapp-cards tr:hover {
	background: transparent !important;
}
.whatsapp-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.whatsapp-cards tr:first-child td {
	padding-top: 12px !important;
}
.whatsapp-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.whatsapp-cards tr + tr td {
	padding-top: 8px !important;
}
.card-label {
	font-size: 13px;
	color: rgba(0, 0, 0, 0.6);
}
/* riga espansa della tabella desktop: niente hover grigio sulla chat */
.wa-expanded,
.wa-expanded:hover {
	background: transparent !important;
}
</style>
